/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useRef } from "react"
import {
    Box,
    CircularProgress,
    LinearProgress,
    Typography,
} from "@mui/material"
import { CwComponentConfig, PageConfig } from "../../models/pageConfig"

const CwProgress = (
    props: PageConfig<CwComponentConfig.CwProgress>
): React.JSX.Element => {
    const timeOutRef = useRef<number>(0)
    const { value, type } = props.config
    const [showError, setShowError] = useState<boolean>(false)

    useEffect(() => {
        timeOutRef.current = window.setTimeout(() => {
            setShowError(true)
        }, 30000)
        return () => clearTimeout(timeOutRef.current)
    }, [])
    if (type === "progress") {
        return (
            <Box position="relative" display="inline-flex">
                <CircularProgress variant="determinate" {...props} />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography
                        variant="caption"
                        component="div"
                        color="textSecondary"
                    >{`${Math.round(value)}%`}</Typography>
                </Box>
            </Box>
        )
    }
    if (type === "loader") {
        return showError ? (
            <h4>
                <p>Un problème est survenu lors du chargement.</p>
                Veuillez essayer plus tard
            </h4>
        ) : (
            <LinearProgress
                data-testid="linearProgress"
                style={{ width: "50%", marginLeft: "25%", marginTop: "10%" }}
            />
        )
    }
    return <h4>404 NOT found</h4>
}

export default CwProgress
